import React, { useMemo, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTable, useColumnOrder } from "react-table";
import PopupDeliveryDetail from "../../components/deliverys/PopupDeliveryDetail";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import * as XLSX from "xlsx";

import {
  clearCheckedLists,
  ResetDeliveryData,
  isNull,
  AddOptionToString,
  addThousandPoint,
  ChangeMobileFormat,
} from "../../../components/common/Common";
import FoundDriverForSelect from "../../../components/popups/FoundDriverForSelect";

const getItemStyle = ({ isDragging, isDropAnimating }, draggableStyle) => ({
  ...draggableStyle,
  userSelect: "none",
  background: isDragging ? "lightgreen" : "grey",
  ...(!isDragging && { transform: "translate(0,0)" }),
  ...(isDropAnimating && { transitionDuration: "0.001s" }),
});

function DeliverySearchResult({
  varTotalCount,
  varColumnLists,
  varMaxNumPage,
  varPageSize,
  setPageSize,
  varDeliveryFee,
  varDriverFee,
  varDeliveryLists,
  setDeliveryLists,
  getDeliveryList,
  excelData,
}) {
  //excel 파일
  const fileRef = useRef();
  const [varShowDeliveryDetail, setShowDeliveryDetail] = useState(false);
  const [searchCarNumber, setSearchCarNumber] = useState("");

  //컬럼 - 제목부
  const columns = useMemo(() => {
    if (varColumnLists?.length > 0) {
      return varColumnLists;
    }
    // eslint-disable-next-line
  }, []);

  //표시할 정보
  const data = useMemo(() => {
    if (varDeliveryLists?.length > 0) {
      return varDeliveryLists.map((item) => ({
        ...item,
        disabled: true,
        buttonText: "변경",
      }));
    }
    // eslint-disable-next-line
  }, [varDeliveryLists]);

  //initialState:{hiddenColumns:["data24"]} <-- 컬럼 숨기기
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    allColumns,
    setColumnOrder,
    state,
  } = useTable(
    { columns, data, initialState: { hiddenColumns: ["data24", "data25"] } },
    useColumnOrder
  );

  const currentColOrder = useRef();
  const [varExcelProgress, setExcelProgress] = useState(false);

  //목록의 모든 항목 선택하기
  const onCheckedAll = (e) => {
    const bChecked = Number(e.currentTarget.checked);
    clearCheckedLists(bChecked);
    //배열값 변경
    let copyDatas = [...varDeliveryLists];
    for (var i = 0; i < copyDatas.length; i++) {
      copyDatas[i].data25 = bChecked;
    }
    setDeliveryLists(copyDatas);
  };

  //목록상의 항목 선택하기
  const onCheckedElement = (e, dc_idx) => {
    const bChecked = Number(e.currentTarget.checked);
    const findIndex = varDeliveryLists.findIndex(
      (element) => element.data24 === dc_idx
    );
    let copyLists = [...varDeliveryLists];
    copyLists[findIndex].data25 = bChecked;
    setDeliveryLists(copyLists);
    CheckAllButtonState();
  };
  //전체선택항목 조정
  const CheckAllButtonState = () => {
    //전체버튼 점검
    let bchecked = true;
    const delItems = document.querySelectorAll(".del-item");
    for (var i = 0; i < delItems.length; i++) {
      if (delItems[i].checked === false) {
        bchecked = false;
        break;
      }
    }
    const chkallItem = document.getElementById("deleteItems");
    chkallItem.checked = bchecked;
  };

  //엑셀 다운로드
  // 엑셀 다운로드
  const onDownloadExcelHandler = (e) => {
    if (!window.confirm("Excel 파일로 다운로드합니까?")) return false;

    // 제목부 배열 생성
    if (excelData.length > 0) {
      let titleArray = { 번호: "" };
      const columns = varColumnLists; // 사용중인 컬럼 목록을 가져옵니다.
      columns.forEach((column) => {
        titleArray[column.Header] = "";
      });

      // 엑셀자료 만들기
      let excelList = excelData.map((item, index) => {
        let newExcelObj = { ...titleArray };
        newExcelObj["번호"] = index + 1; // 번호 추가
        columns.forEach((column) => {
          newExcelObj[column.Header] = item[column.accessor];
        });
        return newExcelObj;
      });

      // 파일로 저장
      const ws = XLSX.utils.json_to_sheet(excelList);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "배차현황");
      XLSX.writeFileXLSX(wb, "더나은물류-배차현황관리.xlsx");
      clearCheckedLists(false);
    } else {
      alert("다운로드할 데이터가 없습니다.");
    }
  };

  //엑셀파일을 선택하기
  const onUploadExcelHandler = (e) => {
    fileRef.current.click();
  };

  //엑셀파일을 읽어오기
  const onSelectedFileHandler = (e) => {
    const fileBox = fileRef.current;
    if (fileBox.value === "" || !fileBox.files) return false;
    setExcelProgress(true);
    const file = fileBox.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e) => {
      if (!e.target) {
        setExcelProgress(false);
        return;
      }
      console.log(e.target.result);
      const bufferArray = e.target.result;
      const fileInformation = XLSX.read(bufferArray, {
        type: "buffer",
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const datas = XLSX.utils.sheet_to_json(rawData);
      console.log(datas);
      if (datas?.length === 0) {
        setExcelProgress(false);
        alert("읽어들일 정보가 존재하지 않습니다. 다른 파일을 선택하세요.");
        return false;
      }
      ReadExcelFileData(datas);
    };
  };
  //읽어드린 엑셀파일정보 재가공
  const ReadExcelFileData = async (datas) => {
    let sendArray = [];
    console.log(datas);
    for (var i = 0; i < datas.length; i++) {
      let sendData = ResetDeliveryData(datas[i]);
      //운전자, 거래처
      if (!isNull(sendData["driver_name"]) || !isNull(sendData["cs_name"])) {
        await axios
          .post(
            `${process.env.REACT_APP_HOST}/_get_delivery_exceldata`,
            sendData
          )
          .then((res) => {
            const datas = res.data;
            if (datas.retvalue === 1) {
              if (datas.members?.length > 0) {
                const datam = datas.members[0];
                sendData["mem_idx"] = datam.mem_idx;
              } else {
                sendData["mem_idx"] = 0;
              }
              if (datas.customers?.length > 0) {
                const datac = datas.customers[0];
                sendData["cs_idx"] = datac.cs_idx;
              } else {
                sendData["cs_idx"] = 0;
              }
              sendArray.push(sendData);
            }
          });
      } else {
        sendArray.push(sendData);
      }
    }
    RegisterExcelFileData(sendArray);
  };
  //DB에 저장하기
  const RegisterExcelFileData = async (sendArray) => {
    for (var i = 0; i < sendArray.length; i++) {
      const sendData = { dataInfo: sendArray[i] };
      const res = await axios.post(
        `${process.env.REACT_APP_HOST}/_register_delivery`,
        sendData
      );
      console.log(i, res);
    }
    setExcelProgress(false);
    alert("배차정보를 등록하였습니다.");
    window.location.reload(); //리로드 페이지
  };

  //컬럼의 순서가 바뀌면
  useEffect(() => {
    SetColumnOrderToStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.columnOrder]);

  const SetColumnOrderToStorage = () => {
    const headArray = state.columnOrder;
    if (headArray.length === 0) return false;
    //객체 표준현 만들기
    let titleArray = [];
    for (var m = 0; m < headArray.length; m++) {
      let columnName = headArray[m];
      titleArray.push(columnName);
    }
    const headString = headArray.join(",");
    localStorage.setItem("deliveryHeaders", headString);
  };

  //선택 항목 삭제
  const onDeleteDeliveryList = async (e) => {
    e.preventDefault();
    //삭제하기위해 선택된 항목 알아내기
    let delitems = 0;
    let boardIndexString = "";
    varDeliveryLists.map((element) => {
      if (element.data25) {
        delitems++;
        boardIndexString = AddOptionToString(
          element.data24,
          boardIndexString,
          ","
        );
      }
      return "";
    });

    if (delitems === 0) {
      alert("삭제할 정보가 선택되어 있지 않습니다.");
      return;
    }
    if (!window.confirm(delitems + "개의 선택된 정보를 삭제합니까?")) return;

    const sendData = { mode: 5, delitems: boardIndexString };
    console.log(sendData);
    await axios
      .post(`${process.env.REACT_APP_HOST}/_delete_board_list`, sendData)
      .then((res) => {
        console.log(res.data);
        if (res.data.retvalue === 1) {
          clearCheckedLists(false);
          getDeliveryList();
        } else {
          alert(res.data.message);
        }
      });
  };
  //예 - Column 재설정
  /* const ChangeColumnOrder = () => {
    setColumnOrder(['data1','data3','data12',...]);
  } */

  /* 항목별로 제목을 누르면 실행하도록 코딩하는 경우 
  <th {...column.getHeaderProps({style:{width:column.width}})} onClick={column.id==='data2'?e=>onSortingListHandler(e,column):null}>
  const onSortingListHandler = (e,column) => {
    console.log(column);
    alert('hello');
  } */

  const onChangePageSizeHandler = (e) => {
    setPageSize(Number(e.currentTarget.value));
  };

  //팝업창 호출
  const [varDeliveryIndex, setDeliveryIndex] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [varOpenFindDriver, setOpenFindDriver] = useState(false);
  const [varSearchDriverList, setSearchDriverList] = useState("");
  const [receiptPayment, setReceiptPayment] = useState([]);
  const [receiptFile, setReceiptFile] = useState("");
  const [changeUserInfo, setChangeUserInfo] = useState({});
  const [originalInfo, setOriginalInfo] = useState({});
  const [searchSuccess, setSearchSuccess] = useState(false);

  const onOpenDeliveryDetail = (e, dc_idx) => {
    setDeliveryIndex(dc_idx);
    setShowDeliveryDetail(true);
  };

  const handleInputChange = (e, rowIndex) => {
    const newValue = e.target.value;

    const frontArr = varDeliveryLists.slice(0, rowIndex);
    const backArr = varDeliveryLists.slice(rowIndex + 1);

    const findArr = varDeliveryLists[rowIndex];
    const findValue = varDeliveryLists[rowIndex]["data8"];
    console.log(findArr, "너다");

    console.log(findValue, newValue);
    setSelectedId(rowIndex);
    setSearchCarNumber(newValue);
    setDeliveryLists([
      ...frontArr,
      { ...findArr, data8: newValue, disabled: true },
      ...backArr,
    ]);
    setChangeUserInfo({ ...findArr, data8: newValue });
  };

  const onSearchDriverHandler = async () => {
    const frontArr = varDeliveryLists.slice(0, selectedId);
    const backArr = varDeliveryLists.slice(selectedId + 1);

    const findArr = varDeliveryLists[selectedId];

    const sendData = { dr_carnumb: searchCarNumber };
    const res = await axios.post(
      `${process.env.REACT_APP_HOST}/admin_find_driver`,
      sendData
    );
    const datas = res.data;
    if (datas.retvalue === 1) {
      if (datas.results?.length === 0) {
        alert("검색된 드라이버가 없습니다.");
        setSearchSuccess(false);
        setDeliveryLists([
          ...frontArr,
          { ...findArr, disabled: true },
          ...backArr,
        ]);
        setChangeUserInfo({
          ...findArr,
        });
      } else if (datas.results?.length === 1) {
        setSearchSuccess(true);
        const driverInfo = datas.results[0];
        setDeliveryLists([
          ...frontArr,
          {
            ...findArr,
            data8: driverInfo.dr_carnumb,
            data9: driverInfo.mem_name,
            data21: ChangeMobileFormat(driverInfo.mem_mobile),
            disabled: false,
            buttonText: "저장",
          },
          ...backArr,
        ]);

        setChangeUserInfo({
          ...findArr,
          dc_driver_idx: driverInfo.dr_mem_idx,
          data8: driverInfo.dr_carnumb,
          data9: driverInfo.mem_name,
          data21: ChangeMobileFormat(driverInfo.mem_mobile),
          disabled: false,
        });
      } else {
        //회원 검색을 비슷한 문자로 진행하는 경우 --> 목록으로 (추후검토))
        const driverList = datas.results;
        console.log(driverList, "너지?");
        setSearchDriverList(driverList);
        setOpenFindDriver(true);
        setDeliveryLists([
          ...frontArr,
          {
            ...findArr,
            disabled: true,
          },
          ...backArr,
        ]);
        setChangeUserInfo({
          ...findArr,
        });
      }
      setSearchSuccess(true);
    } else {
      setSearchSuccess(false);
      setDeliveryLists([
        ...frontArr,
        {
          ...findArr,
          disabled: true,
        },
        ...backArr,
      ]);
      setChangeUserInfo({
        ...findArr,
      });
      alert(datas.message);
    }
  };

  const onKeyPressHandler = (e, rowIndex) => {
    if (e.key === "Enter") {
      onSearchDriverHandler(rowIndex);
    }
  };

  const SelectedDriverAmongFound = (e) => {
    const driver_idx = Number(e.currentTarget.value);

    if (driver_idx === 0) {
      alert("차량번호를 선택해주세요");
      return false;
    }

    const frontArr = varDeliveryLists.slice(0, selectedId);
    const backArr = varDeliveryLists.slice(selectedId + 1);

    const findArr = varDeliveryLists[selectedId];

    const driverInfo = varSearchDriverList.filter(
      (el) => el.dr_mem_idx === driver_idx
    )[0];

    setDeliveryLists([
      ...frontArr,
      {
        ...findArr,
        data8: driverInfo.dr_carnumb,
        data9: driverInfo.mem_name,
        data21: ChangeMobileFormat(driverInfo.mem_mobile),
        disabled: false,
        buttonText: "저장",
      },
      ...backArr,
    ]);

    setChangeUserInfo({
      ...findArr,
      dc_driver_idx: driverInfo.dr_mem_idx,
      data8: driverInfo.dr_carnumb,
      data9: driverInfo.mem_name,
      data21: ChangeMobileFormat(driverInfo.mem_mobile),
      disabled: false,
    });
    setSearchSuccess(true);
    setOpenFindDriver(false);
  };

  const getDeliveryInformation = async () => {
    const userId = changeUserInfo.data24;
    const sendData = { dc_idx: userId };

    await axios
      .post(
        `${process.env.REACT_APP_HOST}/admin_get_delivery_information`,
        sendData
      )
      .then((res) => {
        const datas = res.data;
        console.log(res.data);
        let paymentArray = [1, 0, 0, 0];
        let cs_idx = 0;
        let dataInfo = datas.results[0];
        cs_idx = dataInfo.cs_idx;
        dataInfo.old_driver_idx = dataInfo.dc_driver_idx; //현재 드라이버 저장
        if (datas.retvalue === 1) {
          if (datas.results?.length > 0) {
            cs_idx = dataInfo.cs_idx;
            dataInfo.old_driver_idx = dataInfo.dc_driver_idx; //현재 드라이버 저장
            setOriginalInfo(dataInfo);
            if (dataInfo.dc_receipt_image === 1) {
              setReceiptFile(dataInfo.dc_receipt_file);
            }
            // 인수증 결재방법
            if (!isNull(dataInfo.dc_receipt_payment)) {
              paymentArray = dataInfo.dc_receipt_payment.split(",");
            }
            console.log(paymentArray, "1");
            //console.log(paymentArray);
            setReceiptPayment(paymentArray);
            // setPickupDate({...varPickupDate,dc_riding_date:dataInfo.dc_riding_date,dc_quit_date:dataInfo.dc_quit_date});
          } else {
            setReceiptPayment(paymentArray);
          }
          const { disabled, buttonText, ...filteredUserInfo } = changeUserInfo;

          const deliveryInfo = {
            ...dataInfo,
            dc_driver_idx: filteredUserInfo.dc_driver_idx,
            mem_mobile: filteredUserInfo.data21,
            mem_name: filteredUserInfo.data9,
            dr_carnumb: filteredUserInfo.data8,
          };

          const sendData = {
            deliveryInfo: deliveryInfo,
            fileName: dataInfo.dc_receipt_file,
            recepitPayment: dataInfo.dc_receipt_payment.split(","),
          };

          axios
            .post(
              `${process.env.REACT_APP_HOST}/admin_update_delivery_information`,
              sendData
            )
            .then((res) => {
              const datas = res.data;
              console.log(datas, "성공이다!!");
              getDeliveryList();
              alert("차량번호가 변경되었습니다");
            });
        } else {
          setReceiptPayment(paymentArray);
        }
      });
  };

  const UpdateDeliveryInformation = async () => {
    const { disabled, buttonText, ...filteredUserInfo } = changeUserInfo;

    const deliveryInfo = {
      ...originalInfo,
      mem_mobile: filteredUserInfo.data21,
      mem_name: filteredUserInfo.data9,
      dr_carnumb: filteredUserInfo.data8,
    };

    console.log(deliveryInfo, "delivery");

    const sendData = {
      deliveryInfo: deliveryInfo,
      fileName: receiptFile,
      recepitPayment: receiptPayment.join(","),
    };

    console.log(sendData);
    //!! sendData 리스트에 disabled 제거해야함.

    await axios
      .post(
        `${process.env.REACT_APP_HOST}/admin_update_delivery_information`,
        sendData
      )
      .then((res) => {
        const datas = res.data;
        console.log(datas, "성공이다!!");
        getDeliveryList();
      });
  };

  const onChangeDeliveryInfoHandler = async () => {
    const unsavedChanges = varDeliveryLists.some(
      (item) => item.buttonText === "저장" && item.disabled === true
    );

    if (unsavedChanges) {
      alert("기존 변경사항을 먼저 저장해주세요");
      return;
    }

    if (!searchSuccess) {
      alert("차량번호는 조회로 변경 가능합니다");
      return;
    }

    let sprompt = "차량번호를 변경합니까?";
    if (!window.confirm(sprompt)) return false;

    await getDeliveryInformation();
  };

  const onActiveHandler = (rowIndex) => {
    const unsavedChanges = varDeliveryLists.some(
      (item) => item.buttonText === "저장"
    );

    if (unsavedChanges) {
      alert("기존 변경사항을 먼저 저장해주세요");
      return;
    }

    const frontArr = varDeliveryLists.slice(0, rowIndex);
    const backArr = varDeliveryLists.slice(rowIndex + 1);
    const findArr = varDeliveryLists[rowIndex];

    setDeliveryLists([
      ...frontArr,
      { ...findArr, disabled: false, buttonText: "저장" },
      ...backArr,
    ]);
  };

  return (
    <div className="main-box" style={{ marginTop: "30px" }}>
      <div className="btn-between">
        <div>
          <button onClick={(e) => onUploadExcelHandler(e)} className="btn line">
            EXCEL 읽어오기
          </button>
          <input
            type="file"
            ref={fileRef}
            onChange={(e) => onSelectedFileHandler(e)}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
          />
          {varExcelProgress ? (
            <span style={{ marginLeft: "20px" }}>작업중...</span>
          ) : null}
        </div>
        <div style={{ paddingTop: "12px", fontSize: "15px" }}>
          <span>운임료 합계 : {addThousandPoint(varDeliveryFee)} 원</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>지급원가 합계 : {addThousandPoint(varDriverFee)} 원</span>
        </div>
        <div>
          <span>검색건수 : {addThousandPoint(varTotalCount)} 건</span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <select
            name="pageSize"
            value={varPageSize}
            style={{ width: "120px" }}
            onChange={onChangePageSizeHandler}
          >
            <option value={0}>전체</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
          </select>
          &nbsp;&nbsp;
          <Link to={`/Admin/DeliveryDetail/0`} className="btn-danger">
            배차등록
          </Link>
          <button onClick={(e) => onDeleteDeliveryList(e)} className="btn line">
            배차삭제
          </button>
          <button
            onClick={(e) => onDownloadExcelHandler(e)}
            className="btn line"
          >
            EXCEL 다운로드
          </button>
        </div>
      </div>
      <div className="scroll-table">
        <table className="list scroll delivery" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, y) => (
              <DragDropContext
                key={"header_" + y}
                onDragStart={() => {
                  console.log(allColumns);
                  currentColOrder.current = allColumns.map((o) => o.id);
                }}
                onDragUpdate={(dragUpdateObj, b) => {
                  const colOrder = [...currentColOrder.current];
                  const sIndex = dragUpdateObj.source.index;
                  const dIndex =
                    dragUpdateObj.destination &&
                    dragUpdateObj.destination.index;
                  if (
                    typeof sIndex === "number" &&
                    typeof dIndex === "number"
                  ) {
                    colOrder.splice(sIndex, 1);
                    colOrder.splice(dIndex, 0, dragUpdateObj.draggableId);
                    setColumnOrder(colOrder);
                  }
                }}
              >
                <Droppable droppableId="droppable" direction="horizontal">
                  {(droppableProvided) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      ref={droppableProvided.innerRef}
                    >
                      <th style={{ width: "30px" }}>
                        <input
                          type="checkbox"
                          style={{ marginLeft: "0px" }}
                          id="deleteItems"
                          onChange={(e) => onCheckedAll(e)}
                        />
                      </th>
                      <th style={{ width: "70px" }}>번호</th>
                      {headerGroup.headers.map((column, index) => (
                        <Draggable
                          key={column.id}
                          draggableId={column.id}
                          index={index}
                          isDragDisabled={!column.accessor}
                        >
                          {(provided, snapshot) => {
                            return (
                              <th
                                {...column.getHeaderProps({
                                  style: { width: column.width },
                                })}
                              >
                                <div
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  ref={provided.innerRef}
                                  style={{
                                    ...getItemStyle(
                                      snapshot,
                                      provided.draggableProps.style
                                    ),
                                  }}
                                >
                                  {column.render("Header")}
                                </div>
                              </th>
                            );
                          }}
                        </Draggable>
                      ))}
                      <th style={{ width: "90px" }}>상세</th>
                    </tr>
                  )}
                </Droppable>
              </DragDropContext>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {varDeliveryLists?.length === 0 ? (
              <tr>
                <td colSpan={26}>등록된 배차내역이 없습니다.</td>
              </tr>
            ) : (
              rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    <td className="board-list">
                      <input
                        type="checkbox"
                        className={"del-item"}
                        id={"deleteItem_"}
                        onChange={(e) => onCheckedElement(e, row.values.data24)}
                      />
                    </td>
                    <td>{varMaxNumPage - i}</td>
                    {row.cells.map((cell, j) => {
                      return (
                        <td
                          {...cell.getCellProps({
                            style: { width: cell.column.width },
                          })}
                        >
                          {cell.column.isEditable ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <input
                                type="text"
                                value={cell.value}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    row.index,
                                    cell.column.accessor
                                  )
                                }
                                onKeyPress={(e) =>
                                  onKeyPressHandler(e, row.index)
                                }
                                disabled={
                                  varDeliveryLists[row.index].disabled ===
                                  undefined
                                }
                              />
                              <button
                                style={{
                                  backgroundColor:
                                    varDeliveryLists[row.index].buttonText ===
                                      "저장" &&
                                    !varDeliveryLists[row.index].disabled
                                      ? "red"
                                      : varDeliveryLists[row.index].disabled &&
                                        varDeliveryLists[row.index]
                                          .buttonText !== "변경"
                                      ? "gray"
                                      : "#258afe",
                                  color: "white",
                                  padding: "3px 8px 0",
                                  marginLeft: 10,
                                  height: 30,
                                }}
                                onClick={() => {
                                  const unsavedChanges = varDeliveryLists.some(
                                    (item) => item.buttonText === "저장"
                                  );

                                  unsavedChanges
                                    ? onChangeDeliveryInfoHandler()
                                    : onActiveHandler(row.index);
                                }}
                                disabled={
                                  varDeliveryLists[row.index].disabled &&
                                  varDeliveryLists[row.index].buttonText !==
                                    "변경"
                                }
                              >
                                {varDeliveryLists[row.index].buttonText ||
                                  "변경"}
                              </button>
                            </div>
                          ) : (
                            cell.render("Cell")
                          )}
                        </td>
                      );
                    })}
                    {/* <td><Link to={`/Admin/DeliveryDetail/${row.values.data24}`} style={{width:"70px"}} className="btn line black">상세</Link></td> */}
                    <td>
                      <button
                        className="btn line black"
                        style={{ width: "70px" }}
                        onClick={(e) =>
                          onOpenDeliveryDetail(e, row.values.data24)
                        }
                      >
                        상세
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <PopupDeliveryDetail
        varDeliveryIndex={varDeliveryIndex}
        setDeliveryIndex={setDeliveryIndex}
        varDeliveryLists={varDeliveryLists}
        setDeliveryLists={setDeliveryLists}
        varShowDeliveryDetail={varShowDeliveryDetail}
        setShowDeliveryDetail={setShowDeliveryDetail}
      />
      <FoundDriverForSelect
        varOpenFindDriver={varOpenFindDriver}
        setOpenFindDriver={setOpenFindDriver}
        varSearchDriverList={varSearchDriverList}
        SelectedDriverAmongFound={SelectedDriverAmongFound}
      />
    </div>
  );
}

export default DeliverySearchResult;
